export default __webpack_public_path__ + "static/media/folio-light.096153a5.svg";